import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    getProducts as getProductsApi,
    addNewProduct as addNewProductApi,
    updateProduct as updateProductApi,
    deleteProducts as deleteProductApi
} from "./api";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";

export const getProducts = createAsyncThunk("products/getProducts", async () => {
    try {
        const response = await getProductsApi();
        return response;
    } catch (error) {
        toast.error("Error al obtener los productos", { autoClose: 3000 });
        return error;
    }
});

export const addNewProduct = createAsyncThunk("products/addNewProduct", async (product: any) => {
    try {
        const response = await addNewProductApi(product);
        toast.success("Producto creado exitosamente", { autoClose: 3000 });
        return response;
    } catch (error) {
        toast.error("Error al crear el producto", { autoClose: 3000 });
        return error;
    }
});

export const updateProduct = createAsyncThunk("products/updateProduct", async (product: any) => {
    try {
        const response = await updateProductApi(product);
        toast.success("Producto actualizado exitosamente", { autoClose: 3000 });
        return response;
    } catch (error) {
        toast.error("Error al actualizar el producto", { autoClose: 3000 });
        return error;
    }
});

export const deleteProduct = createAsyncThunk("products/deleteProduct", async (productId: string) => {
    try {
        await deleteProductApi(productId);
        toast.success("Producto eliminado exitosamente", { autoClose: 3000 });
        return productId;
    } catch (error) {
        toast.error("Error al eliminar el producto", { autoClose: 3000 });
        return error;
    }
});
